import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
import '../styles/Blog.css';

const BlogPreview = () => {
  const latest = blogPosts.slice(0, 3);

  return (
    <section id="blog" className="blog-preview-section">
      <div className="blog-container">
        <div className="blog-preview-header">
          <h2 className="blog-preview-title">Latest <span className="highlight-cyan">Writing</span></h2>
          <Link to="/blog" className="blog-view-all">View all →</Link>
        </div>

        <div className="blog-list">
          {latest.map(post => (
            <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card">
              <div className="blog-card-meta">
                <div className="blog-card-tags">
                  {post.tags.map(tag => (
                    <span key={tag} className="blog-card-tag">{tag}</span>
                  ))}
                </div>
                <span className="blog-card-date">{post.date}</span>
              </div>
              <h2 className="blog-card-title">{post.title}</h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <span className="blog-card-read">Read more →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;